import * as React from "react";
import { Link } from "azure-devops-ui/Link";

export default class CustomTargetLinkExample extends React.Component {
    public render(): JSX.Element {
        return (
            <Link href="https://www.microsoft.com/" target="_blank">
                Microsoft home page
            </Link>
        );
    }
}
